import { render, staticRenderFns } from "./album.vue?vue&type=template&id=9abe1e60&scoped=true&"
import script from "./album.vue?vue&type=script&lang=ts&"
export * from "./album.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abe1e60",
  null
  
)

export default component.exports